// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CourseBusinessCalculationController from "./course_business_calculation_controller"
import AttachmentPreviewController from "./attachment_preview_controller"
import DateRangeListController from "./date_range_list_controller"
import DevCourseAutofillController from "./dev_course_autofill_controller"
import DialogController from "./dialog_controller"
import FormSectionNavController from "./form_section_nav_controller"
import GalleryUploadController from "./gallery_upload_controller"
import HeldAtConsentController from "./held_at_consent_controller"
import ImageCropperController from "./image_cropper_controller"
import MandatoryCourseCalculationController from "./mandatory_course_calculation_controller"
import MarketingProductVariantsController from "./marketing_product_variants_controller"
import MicrocredentialCalculationController from "./microcredential_calculation_controller"
import MobileNavController from "./mobile_nav_controller"
import ModalController from "./modal_controller"
import MultiSelectSummaryController from "./multi_select_summary_controller"
import PasswordSetupLinkController from "./password_setup_link_controller"
import ProgramDurationDetailsController from "./program_duration_details_controller"
import ProgramDateRangesController from "./program_date_ranges_controller"
import SearchFormController from "./search_form_controller"
import SupplementaryActivityCalculationController from "./supplementary_activity_calculation_controller"
application.register("course-business-calculation", CourseBusinessCalculationController)
application.register("attachment-preview", AttachmentPreviewController)
application.register("date-range-list", DateRangeListController)
application.register("dev-course-autofill", DevCourseAutofillController)
application.register("dialog", DialogController)
application.register("form-section-nav", FormSectionNavController)
application.register("gallery-upload", GalleryUploadController)
application.register("held-at-consent", HeldAtConsentController)
application.register("image-cropper", ImageCropperController)
application.register("mandatory-course-calculation", MandatoryCourseCalculationController)
application.register("marketing-product-variants", MarketingProductVariantsController)
application.register("microcredential-calculation", MicrocredentialCalculationController)
application.register("mobile-nav", MobileNavController)
application.register("modal", ModalController)
application.register("multi-select-summary", MultiSelectSummaryController)
application.register("password-setup-link", PasswordSetupLinkController)
application.register("program-duration-details", ProgramDurationDetailsController)
application.register("program-date-ranges", ProgramDateRangesController)
application.register("search-form", SearchFormController)
application.register("supplementary-activity-calculation", SupplementaryActivityCalculationController)
